import "core-js/modules/es6.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { LegacyLink } from './LegacyLink';
import { SimpleLink } from './SimpleLink';
var deprecatedProps = ['chronicle', 'color', 'decorated', 'italic', 'unstyled', 'uppercase'];

/**
 * To keep styles simple while also retaining backwards compatibility, this
 * component has been bifurcated into two internal components: `<SimpleLink>`
 * and `<LegacyLink>`. If no deprecated props are used, `<SimpleLink>` will be
 * rendered. Otherwise, `<LegacyLink>` will be used instead.
 *
 * During the next major version bump, `<LegacyLink>` should be removed and
 * `<SimpleLink>` should become the implementation of `<Link>`.
 */
export var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedPropsWarning({
    component: 'Link',
    deprecatedProps: [{
      deprecated: 'chronicle',
      migration: 'Designers should not be using Chronicle in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'color',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'decorated',
      migration: 'All links should appear as default blue at this time, so underline is not needed. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'italic',
      migration: 'Designers should not be using italic in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'uppercase',
      migration: 'All links should appear Body, Body Small or Legal at this time. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'unstyled',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }],
    props: props
  });
  var needsLegacyLink = deprecatedProps.some(function (deprecatedProp) {
    return !!props[deprecatedProp];
  });

  if (needsLegacyLink) {
    return /*#__PURE__*/React.createElement(LegacyLink, _extends({}, props, {
      ref: ref
    }));
  }

  return /*#__PURE__*/React.createElement(SimpleLink, _extends({}, props, {
    ref: ref
  }));
});
Link.displayName = 'Link';